import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { ParkingCapacity } from 'types/generatedSchemaTypes';

const MetaShrink = styled(Meta)<{ color?: string }>`
  flex-shrink: 1;
  text-decoration: ${(p) => (p.isLink ? 'underline' : 'none')};
  text-decoration-color: ${(p) => (p.isLink ? theme.colors.link : p.color)};
`;

type CapacityInfoProps = {
  capacity?: ParkingCapacity | null;
  testID?: string;
};
const CapacityInfo = ({ capacity, testID }: CapacityInfoProps) => {
  const { t } = useTranslation();
  const {
    free: freeSpaces,
    total: totalSpaces,
    capacityStatus,
  } = capacity ?? {};

  const getIconAndColor = () => {
    if (capacityStatus == 'FULL') {
      return <Icon name="NoCapacityIcon" size={8} />;
    }
    if (capacityStatus == 'ALMOST_FULL') {
      return (
        <Icon name="PartialCapacityIcon" size={8} color={theme.colors.white} />
      );
    }
    return <Icon name="FullCapacityIcon" size={8} />;
  };

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
      }}>
      <Icon
        name="ParkingIconForCapacityListView"
        color={theme.colors.gray300}
        size="s"
      />
      {getIconAndColor()}
      <MetaShrink color={theme.colors.gray200} testID={testID}>
        {t('parking.capacityInfo', {
          available: freeSpaces,
          total: totalSpaces,
        })}
      </MetaShrink>
    </View>
  );
};

export default CapacityInfo;
